/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  theme.alinga = {};

theme.alinga.footerMenuAccordian = () => {
  if(window.innerWidth <= 749){
    const accordionBtns = document.querySelectorAll(".mobileAccordion .footer__block__title");

    accordionBtns.forEach((accordion) => {
      accordion.onclick = function () {
        this.classList.toggle("active");

        let content = this.nextElementSibling;
        console.log(content);

        if (content.style.maxHeight) {
          content.style.maxHeight = null;
          console.log(content.scrollHeight);
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
          console.log(content.style.maxHeight);
        }
      };
    });
  }
}

theme.alinga.sizeChartPopup = () => {
  const triggerValue = document.querySelector('.size-chart-trigger');
  const fromWrapper = document.querySelector('.product__page .form__wrapper');
  const targetValue = document.querySelector('.size-chart-popup-wrapper');
  const bodyClass = document.querySelector('.template-product');
  const sizeChartValue = document.querySelector('.size-chart-popup-wrapper .handle-svg');
  const removeValue = document.querySelector('.product-modal__close');
  const bodyClassRemove = document.querySelector('.product-modal__overlay');

  if (!triggerValue || !fromWrapper || !targetValue || !bodyClass) return;

  triggerValue.addEventListener('click', (e) => {
    e.preventDefault();

    fromWrapper.classList.toggle("size-chart-active");
    targetValue.classList.toggle("active");

    bodyClass.classList.add("no-scrollbar");
  });

  if (sizeChartValue) {
    sizeChartValue.addEventListener('click', () => {
      targetValue.classList.toggle("increase--chart");
    });
  }

  if (removeValue) {
    removeValue.addEventListener('click', () => {
      targetValue.classList.remove("active");
      fromWrapper.classList.remove("size-chart-active");
      targetValue.classList.remove("increase--chart");
      bodyClass.classList.remove("no-scrollbar");
    });
  }

  if (bodyClassRemove) {
    bodyClassRemove.addEventListener('click', () => {
      targetValue.classList.remove("active");
      fromWrapper.classList.remove("size-chart-active");
      bodyClass.classList.remove("no-scrollbar");
    });
  }
};



theme.alinga.sizeChartTableHover = () => {
  let tableRow = document.querySelectorAll('.sc-table tr');
  let tableHeader = document.querySelectorAll('.sc-table tr th');
  let tableDetail = document.querySelectorAll('.sc-table tr td');
  let tableMain = document.querySelectorAll('.sc-table .sc-header');
  let tableMainRow = document.querySelectorAll('.sc-table .sc-header th');
  
  tableRow.forEach((tablerow) => {
    tablerow.addEventListener('mouseover', function() {
      this.classList.add("highlight");
    });
    tablerow.addEventListener('mouseout', function() {
      this.classList.remove("highlight");
    });
  });

  tableHeader.forEach((tableheader) => {
    tableheader.addEventListener('mouseover', function(){
      this.classList.add("activeCell");
    });
    tableheader.addEventListener('mouseout', function(){
      this.classList.remove("activeCell");
    });
  });

  tableDetail.forEach((tabledetail) => {
    tabledetail.addEventListener('mouseover', function(){
      const data_index = this.dataset.index;
      const cells = document.querySelectorAll('.sc-table tr td[data-index="'+data_index+'"]');
      cells.forEach(cell => cell.classList.add("highlight"));
      this.classList.add("activeCell");
    });
    tabledetail.addEventListener('mouseout', function(){
      const data_index = this.dataset.index;
      const cells = document.querySelectorAll('.sc-table tr td[data-index="'+data_index+'"]');
      cells.forEach(cell => cell.classList.remove("highlight"));
      this.classList.remove("activeCell");
    });
  });

  tableMain.forEach((tablemain) => {
    tablemain.addEventListener('mouseover', function(){
      this.classList.remove("highlight");
    });  
  });

  tableMainRow.forEach((tablemainrow) => {
    tablemainrow.addEventListener('mouseover', function(){
      const data_index = this.dataset.index;
      const cells = document.querySelectorAll('.sc-table tr td[data-index="'+data_index+'"]');
      cells.forEach(cell => cell.classList.add("highlight"));
    });

    tablemainrow.addEventListener('mouseout', function(){
      const data_index = this.dataset.index;
      const cells = document.querySelectorAll('.sc-table tr td[data-index="'+data_index+'"]');
      cells.forEach(cell => cell.classList.remove("highlight"));
    });
  });
};


// theme.alinga.sizeChartPopup = () => {
//   let triggerValue = document.querySelector('.size-chart-trigger');
//   let targetValue = document.querySelector('.size-chart-popup-wrapper');
//     let closePopup = document.querySelector('.close-icon-svg');
//   triggerValue.onclick = function(){
//     targetValue.classList.add('active');
//     document.querySelector('.template-product').classList.add('no-scrollbar');
//   }
//   closePopup.onclick = function(){
//     targetValue.classList.remove('active');
//     document.querySelector('.template-product').classList.remove('no-scrollbar');
//   }
// }
 
document.addEventListener('DOMContentLoaded', () => {
  theme.alinga.footerMenuAccordian();
  theme.alinga.sizeChartPopup();
  theme.alinga.sizeChartTableHover();
});

document.querySelectorAll('.modal-toggle').forEach(function(modalToggle) {
  modalToggle.addEventListener('click', function(e) {
    e.preventDefault();
    var id = this.getAttribute('data-id');
    var modal = document.querySelector('.modal-data-' + id);
    if (modal) {
      modal.classList.toggle('is-visible');
    }
  });
});



  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
